export interface NumericFormatterOptions {
  /**
   * Minimum number of fraction digits to display.
   * Defaults to undefined (use locale default).
   */
  minimumFractionDigits?: number
  /**
   * Maximum number of fraction digits to display.
   * Defaults to undefined (use locale default).
   */
  maximumFractionDigits?: number
}

export const NumericFormatter = (
  value: number,
  options?: NumericFormatterOptions
): string => {
  return value.toLocaleString(undefined, options)
}
